import { computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useSurveyStore } from "../survey";
import { useToastsStore } from "@/stores/toastsStore";

export const useSurveyStatusStore = defineStore("surveyStatus", () => {
  // imported stores
  const surveyStore = useSurveyStore();
  const { survey } = storeToRefs(surveyStore);
  const toasts = useToastsStore();

  const currentStatus = computed(() => survey.value?.status);
  const updateStatus = (value) => {
    if (value !== survey.value.status && survey.value.unresolved_review_threads_count > 0) {
      toasts.warning(
        "Unresolved review comments",
        "This questionnaire still has open comment threads. Consider resolving them before moving on.",
      );
    }
    survey.value.status = value;
  };
  const statusOptions = computed(() => [
    { label: "Draft", value: "draft" },
    { label: "Review", value: "review" },
    { label: "Live", value: "live" },
    { label: "Paused", value: "paused" },
    { label: "Complete", value: "complete" },
    { label: "Admin", value: "admin" },
    { label: "Archive", value: "archive" },
  ]);

  const isSurveySavedAsDraft = computed(() => survey.value?.saved_as_draft);

  return {
    currentStatus,
    isSurveySavedAsDraft,
    updateStatus,
    statusOptions,
  };
});
